export default Object.freeze({

  YEAR: " year",
  MONTH: " month",
  MONTHS: " months",
  DAY: " day",
  HOUR: " hour",
  MINUTE: " minutes",
  SELECT_REPORT_TYPE: "Please select at least one channel to generate the report.",

  /// ---------------------------- Menu Bar ---------------------------- 
  CHANNEL_1: "Channel 1",
  CHANNEL_2: "Channel 2",
  CHANNEL_3: "Channel 3",
  CHANNEL_4: "Channel 4",

  LIVE_LIST: "Live List",
  LIVE_LIST_MATRIX: "Matrix",
  OSCILLOSCOPE: "Oscilloscope",
  BAR_GRAPH: "Bar graph",
  LOG: "Log",
  REPORT: "Report",
  CONFIG: "Settings",

  PORTUGUESE: "Portuguese",
  ENGLISH: "English",
  SPANISH: "Spanish",

  UPDATING_LANGUAGE_WAITING: "Changing language, please wait a moment",
  UNABLE_TO_ALTER_LANGUAGE: "Unable to change program language.\n",

  // ---------------------------- Live List ----------------------------
  GOOD_STRING: "Good",
  ATTENTION_STRING: "Attention",
  BAD_STRING: "Bad",
  FAULT_STRING: "Fault",
  UNKNOWN_STRING: "Unknown",

  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filter by address or status",

  REASON_ASI: "Reason: ",

  REMOVE_POSITIONING: "Delete device in fault state",
  REMOVE_DEVICE_MODAL_CONTENT_1: "Are you sure you want to delete the device?",
  REMOVE_DEVICE_SUCCESS: "The device will be removed on the next scan.",
  REMOVE_DEVICE_FAILURE: "An error occurred while removing the device: ",
  ADDRESS: "Address",
  AMPLITUDE: "Amplitude",
  DEVIATION: "Deviation",
  NOISE: "Noise",
  STATUS: "Signal",
  FAULT: "Fault",
  RETRIES: "Retries",
  I0: "I0",
  I1: "I1",
  I2: "I2",
  I3: "I3",

  MILLIVOLT: "V",
  VOLTAGE: " V",
  VOLTAGE_PEAK_TO_PEAK: " V",
  A: "A",
  B: "B",
  MASTERS: "Masters",
  SLAVES: "Slaves",
  BAUD_RATE_KBPS: "BAUD RATE (Kbps)",
  CURRENT_CHANNEL: "Current channel",

  NETWORK_DATA: "Network data",

  DETECTED_PROBLEMS: "Problems detected:",
  INIT_PICO_NOT_FOUND: "TS Scope ASi has encountered an internal error that prevented it from functioning correctly. Please restart TS Scope ASi. If the problem persists, please contact Toledo & Souza for support.",
  MONGO_OFF: "TS Scope ASi has detected an error in its internal database. Please restart TS Scope ASi. If the problem persists, please contact Toledo & Souza for support.",
  PICO_NOT_FOUND: "TS Scope ASi has encountered an internal error that prevented it from functioning correctly. Please restart TS Scope ASi. If the problem persists, please contact Toledo & Souza for support.",
  SCAN_FAIL_FOUND: "TS Scope ASi has lost connection with the ASi network, please make sure it is properly connected to the network. After connecting, please restart TS Scope ASi.",
  INVERTED_POLARITY_FOUND: "The TS Scope ASi detected that the cables connected to it have reversed polarity. This can cause instability in reading network packets, causing non-existent slaves on the network to appear in the Live List. To correct this problem, reconnect the cables correctly and then restart the TS Scope ASi.",
  INVERTED_POLARITY: "Inverted polarity",

  A_DEVICES: "Devices A",
  B_DEVICES: "Devices B",

  AMPLITUDE_POPUP_STR1: "Shows the current signal amplitude of each ASi device in the network.",
  AMPLITUDE_POPUP_STR2: "The minimum value is 4 Vpp and the maximum is 8 Vpp.",
  NOISE_POPUP_STR: "Noise in ASi networks has a limit of 30% of the signal amplitude value.",
  DEV_POPUP_STR1: "Indicates the deviation value of the signal in relation to the frequency oscillator, that is, the time relationship between where the signal should cross zero and where it actually is crossing.",
  DEV_POPUP_STR2: "It may indicate capacitive coupling to the bus or a hardware problem.",
  DEV_POPUP_STR3: "The limits are -0.8μs to +1.6μs.",
  RETRIES_POPUP_STR_1: "Retries indicate the number of times packet loss occurred and the master had to resend a query to a given device.",
  RETRIES_POPUP_STR_2: "Retries are calculated within the monitor's data acquisition buffers, which work by performing acquisitions at intervals, alternating between the 4 channels.",

  STATUS_POPUP_STR_1: "Signal quality",
  STATUS_POPUP_STR_2: "• Amplitude from 4 to 8 V",
  STATUS_POPUP_STR_3: "• Amplitude from 2,5 to 4 V",
  STATUS_POPUP_STR_4: "• Amplitude smaller than 2.5 V",
  STATUS_POPUP_STR_5: "or Amplitude greater than 8 V",
  STATUS_POPUP_STR_6: "• Indicates that the slave stopped communicating, that is, it stopped exchanging data with the master (dropped off the network).",

  I_POPUP_STR: "These columns show the data bits in the slave responses.",

  PS: "PS:",

  CANCEL: "Cancel",

  NO_ACTIVE_NETWORK: "TS Scope ASi did not find an active network, please make sure it is correctly connected to an ASi network. After connecting, please restart TS Scope ASi.",

  CHANNEL_TAG_STR: "Channel tag",
  MASTER: "Master",
  SLAVE: "Slave",

  TIME_ON: "Time on:",

  // ---------------------------- Oscilloscope ----------------------------
  GRAPH: "Chart",
  WAVE_FORM: "Waveform",
  ADDRESS_DP: "Address: ",
  CHANNEL_DP: "Channel: ",
  WAVE_B_A: "B - A signal",

  NANOSSECOND: "ns",
  MICROSSECOND: " µs",
  MILLISSECOND: " ms",

  TIME_NS: "Time (ns)",
  TIME_US: "Time (μs)",
  TIME_MS: "Time (ms)",

  AMPLITUDE_PLACEHOLDER: "0,0 V",
  TIME_INTERVAL_PLACEHOLDER: "0,0 ",
  CURSORS: "Cursors",
  CONTROLS: "Controls ",
  TIME_INTERVAL: " time",
  CONTROLS_POPUP_TEXT: "After pressing PLAY, the waveform is updated every 2 seconds.",
  CONTROLS_POPUP_TEXT_2: "To release the controls, you must select manual view and choose a device.",

  VISUALIZATION: "Visualization",
  AUTOMATIC: "Automatic",
  MANUAL: "Manual",

  KBPS: "Kbps",

  TIME_DP: "Time: ",

  PS_1: "PS 1:",
  PS_2: "PS 2:",
  PS_3: "PS 3:",

  // ---------------------------- Bar Graph ----------------------------
  ORDER_BY: "Order by",
  AMPLITUDE_ASC: "Ascending amplitude",
  AMPLITUDE_DESC: "Descending amplitude",
  ADDRESS_ASC: "Ascending address",
  VOLTAGE_V: "Voltage (V)",
  VOLTAGE_V_PEAK_TO_PEAK: "Voltage (V)",
  LOADING: "Loading",
  BAR_GRAPH_TYPE_PLACEHOLDER: "Select a bar chart type",
  MICROSSECOND_TITLE: "Microseconds (µs)",

  NOISE_ASC: "Ascending noise",
  NOISE_DESC: "Descending noise",

  DEVIATION_ASC: "Ascending deviation",
  DEVIATION_DESC: "Descending deviation",

  // ---------------------------- Log ----------------------------
  INSERT_VALID_ADDRESS_OR_TYPE: "Please enter a valid address or event type.",
  BEFORE_MONITOR_INIT_STR: "Before the last initialization",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filter by address or event type",
  LOG_WAITING: "Loading log data",
  HORARY: "Time",
  DESCRIPTION: "Description",
  TYPE: "Type",

  ASI_DEVIATION_LOG_DESCRIPTION: "TS Expert has detected a possible deviation condition in the ASi signal.",
  ASI_ATTENUATED_SIGNAL_LOG_DESCRIPTION: "TS Expert has detected a possible attenuated ASi signal condition.",
  ASI_NOISE_LOG_DESCRIPTION: "TS Expert has detected a possible noisy condition in the ASi network.",
  ASI_NO_SIGNAL_LOG_DESCRIPTION: "TS Expert detected that TS Scope ASi was unable to read this slave in its scans.",
  ASI_GENERAL_SIGNAL_LOSS_DESCRIPTION: "TS Scope ASi has detected a possible overall loss of ASi signal. Please check if the cable has been removed from the channel, or if it has poor contact.",
  ASI_RETRY_LOG_DESCRIPTION: "TS Expert has detected the possible presence of a retry.",
  ASI_FAULT_LOG_DESCRIPTION: "TS Expert has detected a potential fault condition.",
  EVENT_CHECKED_SUCCESS: "The event was cleared successfully.",

  // ---------------------------- Report ----------------------------
  REPORT_EXPORT_NAME: "TS Scope ASi Report",

  HEADER_TEXT: "TS Scope ASi",
  GENERATE_REPORT: "Generate report",

  GENERAL_REPORT: "General Report – TS Scope ASi",
  DATA_REPORT: "Data Report – TS Scope ASi",

  CLIENT_INFO: "Client information",
  EXECUTING_COMPANY_INFO: "Executing company information",
  CONFORMITY: "Conformity",
  ANNOTATIONS: "Notes",
  CONCLUSION: "Conclusion",

  DROPDOWN_PLACEHOLDER: "Choose an option",
  CONFORM: "Conform",
  CONFORM_W_RESTRICTION: "Conform with restrictions",
  NON_CONFORM: "Non-conforming",

  PROJECT_NAME: "- Project name:",
  NETWORK_NAME: "- Network name:",
  LOCATION: "- Location:",
  COMPANY_NAME: "- Company name:",
  ACCOUNTABLE_NAME: "- Name of person in charge:",
  COMPANY_ADDRESS: "- Address:",
  COMPANY_CITY: "- City:",
  COMPANY_TEL: "- Telephone:",

  EXECUTING_COMPANY_NAME: "- Company name:",
  EXECUTING_ACCOUNTABLE_NAME: "- Name of person in charge:",
  EXECUTING_TEL: "- Telephone:",
  EXECUTING_EMAIL: "- Email:",

  ETHERNET_INFO: "ETHERNET information",

  IP_DP: "- IP: ",
  MASK_DP: "- Mask: ",
  GATEWAY_DP: "- Gateway: ",

  NETWORK_NAME_DP: "- Network name: ",

  SUMMARY: "Summary",
  CHANNEL: "Channel",
  LIVE_LIST_PAGE_TITLE: "1 - Live List",
  OSCILLOSCOPE_PAGE_TITLE: "2 - Oscilloscope",
  BAR_GRAPH_PAGE_TITLE: "3 - Bar graph",
  LOG_PAGE_TITLE: "4. - Event log",

  LAST_200_EVENTS: "200 last events",

  PROTOCOL: "- Protocol:",
  PROTOCOL_TYPE: "ASi",

  ANALYZER_VERSION_STRING: "- TS Scope ASi version:",
  ANALYSIS_INIT: "- Analysis start time:",

  SOFTWARE_VERSION: "- Sofware version:",
  BAUD_RATE: "- Baud rate:",
  NUM_MASTERS: "- Masters:",
  NUM_SLAVES: "- Slaves:",

  LIVE_LIST_DOTS: ".....................................................................................................................................",
  BAR_DOTS: "...................................................................................................................................",
  OSC_DOTS: ".............................................................................................................................",
  LOG_DOTS: ".............................................................................................................................................",
  DISCLAIMER_DOTS: "...............................................................................................................................",

  GENERATING_REPORT_WAITING: "Generating report, please wait",

  SIGNAL_DP: "Signal: ",
  AMPLITUDE_DP: "Amplitude: ",
  DEVIATION_DP: "Deviation: ",
  NOISE_DP: "Noise: ",

  END_OF_REPORT: "End of report",
  DISCLAIMER: "Legal notice",
  DISCLAIMER_TEXT: "The data and values presented in this report are merely auxiliary for the ASi specialist, in such a way that any correction indication must be made by the user. For this reason, it is recommended to be accompanied by a certified ASi engineer or technician responsible for the analysis to certify the information provided by the product. Therefore, Toledo & Souza disclaims any liability, loss or damage, direct or indirect, caused by the interpretations of the software, not offering any guarantee in relation to the integrity, quality or adequacy of the information provided, as they depend on the technical analysis of a trained professional, in the absence of this, the user will assume the risk that the content may be inaccurate, incomplete or may not meet their needs and requirements.",

  RETIES_DP: "Retries: ",
  I0_DP: "I0: ",
  I1_DP: "I1: ",
  I2_DP: "I2: ",
  I3_DP: "I3: ",

  // ---------------------------- Manage Information ----------------------------
  SAVE: "Save",
  REMOVE: "Remove",
  YES: "Yes",
  NO: "No",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN: "LOGIN",
  ENTER: "Login",
  LOGOUT: "Logout",
  RESTART_SYSTEM: "Restart System",
  IP: "IP",
  MASK: "Mask",
  GATEWAY: "Gateway",
  TAG: "Tag",
  SETUP: "Configure",
  EDIT: "Edit",
  SOFTWARE_UPDATE: "Software Update",
  INTERFACE_CONFIG: "Interface Settings",
  CURRENT_VERSION: "Current version: ",
  UPDATE: "Update",
  ALTER_LOGIN: "Change login",
  ARE_YOU_SURE_ALTER_CONFIG: "Are you sure you want to change the TS Scope ASi settings?",
  INVALID_OR_CORRUPT_FILE: "The file is invalid or corrupted.",
  IMPORT: "Import",
  EXPORT: "Export",
  LOGIN_CREDENTIALS_FAILURE: "An error occurred while logging in: Incorrect username or password.",
  LOGIN_GENERAL_FALIURE: "An error occurred while logging in:",

  GPG_ALERT_MESSAGE: "You can only send files with the .gpg extension",
  GPG_FILE_EXTENSION: ".gpg",

  SEND_FILE_FAILURE: "An error occurred while uploading the file.",
  SEND_FILE_WAITING: "Sending the file.",
  SEND_FILE_WRONG_FILENAME: "Invalid name. The update file should be called: updatePB.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "The update file was corrupted while uploading.",
  SEND_CONFIG_FAILURE: "An error occurred while sending the settings.",
  SEND_CONFIG_WAITING: "Sending settings.",
  SEND_CONFIG_WAITING_2: "Finishing sending the settings.",
  SEND_CONFIG_DONE: "Settings sent.",
  WAITING: "Please wait a moment",
  CLEAN_LOG_SUCCESS_1: "The log of 'Channel ",
  CLEAN_LOG_SUCCESS_2: "' was successfully cleaned.",
  CLEAN_LOG_FAILURE: "An error occurred while clearing the log.",
  CLEAR: "Clear",
  CHANGE_USERNAME_SUCCESS: "Your username has been changed successfully. Please login again.",
  CHANGE_USERNAME_FAILURE: "An error occurred while changing the username: ",
  USERNAME_TOO_SHORT: "Username must contain at least one character.",
  PASSWORD_MISSMATCH: "The entered passwords do not match",
  CHANGE_PASSWORD_SUCCESS: "The password has been changed successfully. Please login again.",
  CHANGE_PASSWORD_FAILURE: "An error occurred while changing the password: ",

  VERIFY_THE_FOLLOWING_INFO: "Please verify the following information:",
  INVALID_IP: "\n- The entered IP is invalid",
  INVALID_SUBMASK: "\n- The entered mask is invalid",
  INVALID_GATEWAY: "\n- The entered gateway is invalid",
  INVALID_DNS: "\n- The entered DNS is invalid",
  LOOPBACK_IP: "\n- The loopback IP (127.0.0.1) cannot be used as the TS Scope ASi IP",
  LOOPBACK_IP_NTP: "\n- The loopback IP (127.0.0.1) cannot be used as the NTP server IP",
  TAG_TOO_LONG: "Tag length cannot exceed 30 characters",
  SELECT_TIMEZONE: "\n- You must select a Timezone to configure the NTP server",
  SUBNET_OVERLAP_WLAN: "\n- TS Scope ASi detected that there is an overlap in addresses between the ETHERNET interface subnet and the WLAN subnet. For this reason, it is not possible to configure the WLAN with the chosen IP address and mask.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- TS Scope ASi has detected that there is an overlapping address between the ETHERNET interface subnet and the WLAN subnet. For this reason, it is not possible to configure the ETHERNET interface with the chosen IP address and mask.",
  ZERO_IP_MSG: "\n- IP 0.0.0.0 cannot be used as the the TS Scope ASi's IP",
  ZERO_IP_MASK_MSG: "\n- The IP 0.0.0.0 cannot be used as a network mask",
  BROADCAST_IP_MSG: "\n- The network broadcast IP cannot be used as the TS Scope ASi's IP",
  NETWORK_IP_MSG: "\n- Network IP cannot be used as TS Scope ASi's IP",
  BROADCAST_GATEWAY_MSG: "\n- The network broadcast IP cannot be used as the gateway IP",
  NETWORK_GATEWAY_MSG: "\n- The network IP cannot be used as the gateway IP",

  CHOOSE_A_CHANNEL: "To save the tag you need to select a channel",

  ALTER_USERNAME: "CHANGE USER",
  ALTER_PASSWORD: "CHANGE PASSWORD",

  CONFIRM_RESTART_SYSTEM: "Are you sure you want to restart the system?",
  RESTART_SYSTEM_FAILURE: "An error occurred while trying to restart the system.",
  RESTART_SYSTEM_SUCCESS: "Reboot request sent successfully. Please wait about 3 minutes for the system to reboot completely.",

  SELECT_FILE: "Please select a file to upload",

  DO_NOT_CLOSE_THIS_TAB: "Leave this tab open to follow the update.",
  UPDATING_MONITOR_FILES: "Updating files in TS Scope ASi. Please wait.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Files updated, preparing to restart TS Scope ASi.",
  RESTARTING_MONITOR_WAIT: "Restarting TS Scope ASi, please wait a few minutes.",
  UPDATE_SUCCESS: "The update was carried out successfully!",
  UPDATE_ERROR_STRING: "The following error occurred while updating TS Scope ASi: ",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modify at least one of the fields to update the interface settings.",
  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nRemember to update the address in your browser to: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "The interface settings were updated successfully!",

  ALTER: "Change",
  CHANNELS: "Channels",
  CHANNELS_TAGS: "Channel Tags",
  DEVICES_TAGS: "Device Tags",

  TAG_AND_NOTE_FROM_CHANNEL: "Channel ",
  WAS_SUCCESSFULLY_ALTERED: " tag was changed successfully!",
  ALTER_TAG_ERROR: "An error occurred while changing the channel tag ",
  ALTER_TAG_ERROR_REASON: ".\nReason: ",
  ERROR_REASON: ".\nReason: ",

  NOTE: "Note",

  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Ethernet interface configuration field.",
  ETHERNET_POPUP_2: "Used for supervision and web access to TS Scope ASi data.",

  WLAN: "WLAN",
  WLAN_POPUP_1: "Wireless interface configuration field, when an adapter is available.",
  WLAN_POPUP_2: "Used for supervision and web access to TS Scope ASi data.",

  SEND_NTP_CONFIG_WAITING: "Sending NTP server settings.",

  NTP_SERVER: "NTP server",

  TURN_NTP_SERVER_ON: "Turn on NTP Server",
  TURN_NTP_SERVER_OFF: "Turn off NTP server",
  TURN_NTP_SERVER_ON_QUESTION: "Are you sure you want to turn on the NTP server? To do this, the TS Scope ASi will need to be restarted.",
  TURN_NTP_SERVER_OFF_QUESTION: "Are you sure you want to turn off the NTP server? To do this, TS Scope ASi will need to be restarted.",

  PROCESSING_NTP_INIT: "Starting processing of NTP server information.",
  PROCESSING_NTP_INFO: "Processing NTP server information.",
  PROCESSED_NTP_INFO: "NTP server information processed.",
  PROCESSING_NTP_ERROR: "An error occurred while sending information to the NTP server. Check that the server's IP address is correct. If so, also check if the NTP service is turned on and try again.",

  NTP_INFO_TURNED_ON_FAILURE: "An error occurred while turning on the NTP server.",
  NTP_INFO_FAILURE: "Failed to synchronize with the server. If the error persists, contact the NTP server administrator.",

  MONITOR_RESTART_SUCCESS: "TS Scope ASi has been successfully restarted.",
  MONITOR_RESTART_FAILURE: "An error occurred while restarting TS Scope ASi.",

  NTP_INFO_TURNED_OFF_FAILURE: "An error occurred when turning off the NTP server.",

  TAG_WAS_CHANGED_SUCCESSFULLY: "TS Scope ASi tag has been modified successfully.",
  TAG_CHANGE_FAILURE: "An error occurred while modifying the TS Scope ASi tag.",

  TS_EXPERT_CONFIG_POPUP: "Allows you to enable/disable non-conformities to be reported by the tool.",
  DNS: "DNS",

  USERNAME: "User",
  NEW_PWD: "New password",
  REPEAT_PWD: "Repeat password",

  TS_SCOPE_ASI_TAG: "TS Scope ASi tag",
  TEST_NETWORK: "Test network",

  TS_SCOPE_ASI_REPORT_CHANNEL: "TS Scope ASi Report - Channel",
  REPORTS_TS_SCOPE_ASI: "Reports - TS Scope ASi.zip",

  PROJECT_NAME_: "Project name",
  NETWORK_NAME_: "Network name",
  LOCATION_: "Location",
  COMPANY_NAME_: "Company name",
  RESPONSIBLE_NAME: "Name of the person in charge",
  ADDRESS_: "Address",
  CITY: "City",
  TEL: "Telephone",
  CLIENT_LOGO: "Client logo",
  EMAIL: "E-mail",
  EXECUTING_COMPANY_LOGO: "Executing company logo",
  CHANNELS_INCLUDED_REPORT: "Channels included in the report",

  // ---------------------------- Edit Tags page related ----------------------------
  ADD_ALTER_TAGS: "Add/Change Tags",
  CHOOSE_DEVICE: "Choose a device",
  NEW_TAG: "New TAG",
  REMOVE_ALL_TAGS: "Remove All Tags",
  CONFIRM_REMOVE_ALL_TAGS: "Are you sure you want to remove tags from all devices?",
  CHANGE_TAG_SUCCESS: "The tag was changed successfully.",
  CHANGE_TAG_FAILURE: "An error occurred while changing the tag",
  REMOVE_TAG_SUCCESS: "Tags have been removed successfully.",
  REMOVE_TAG_FAILURE: "An error occurred while removing tags",
  IMPORT_TAGS_SUCCESS_1: "The channel tags ",
  IMPORT_TAGS_SUCCESS_2: " were successfully imported",

  IMPORT_TAGS_FAILURE: "An error occurred while importing tags: ",
  PLEASE_SELECT_TAG_FILE: "Please select a tag file.",
  IMPORT_TAGS: "Import tags",
  EXPORT_TAGS: "Export tags",

  CHOOSE_A_CHANNEL_FIRST: "You must select a channel first",
  CHOOSE_A_DEVICE_FIRST: "You must select a device first",

  EXPORT_TAGS_FILENAME: "tags-channel-",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "WLAN adapter",
  WLAN_CONFIG: "WLAN Settings",
  CONNECTION_STATUS: "Connection status",

  WLAN_ADAPTER_ON: "On",
  WLAN_ADAPTER_OFF: "Off",

  IP_PLACEHODLER: "192.168.2.210",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Signal strength",
  FREQUENCY: "Frequency",
  QUALITY: "Quality",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  QUALITY_PLACEHOLDER: "Quality",

  TURNING_WLAN_OFF_WAITING: "Turning off WLAN adapter, please wait.",
  TURNING_WLAN_ON_WAITING: "Turning on WLAN adapter, please wait.",

  NETWORK: "Network",
  NETWORK_NAME_1: "Network name",
  SUBMASK: "Mask",
  PASSWORD: "Password",

  CONNECTED: "Conected",
  DISCONNECTED: "Disconnected",

  WLAN_STATUS_POPUP_1: "Indicates the status of the TS Scope ASi WLAN adapter.",
  WLAN_STATUS_POPUP_2: "If it is turned off, you cannot change the WLAN settings.",

  CONNECTION_STATUS_POPUP_1: "Indicates whether or not the TS Scope ASi is connected to the configured WLAN network.",

  WLAN_CONFIG_POPUP_1: "Settings cannot be changed while the WLAN adapter is turned off.",
  WLAN_CONFIG_POPUP_2: "It is highly recommended that the WLAN settings are only changed when accessing the TS Scope ASi via the wired network.",
  WLAN_CONFIG_POPUP_3: "When changing the IP/mask, if the fields appear blank after the update, this is a strong indication that:",
  WLAN_CONFIG_POPUP_4: "There is already another device on the network with the same IP;",
  WLAN_CONFIG_POPUP_5: "The network mask is too restrictive and does not support the IP that was passed.",

  WLAN_ADAPTER_NOT_FOUND_1: "TS Scope ASi could not find the WLAN adapter:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Check if the adapter is disconnected or has poor contact;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • If the adapter is not disconnected or has bad contact, try replacing it;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • If none of the above options solve the problem, contact Toledo e Souza.",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modify at least one of the fields to update the WLAN settings.",
  UPDATE_WLAN_CONFIG_SUCCESS: "The WLAN settings have been updated successfully!",
  SEND_WLAN_CONFIG_WAITING: "Sending the settings, please wait. This may take about a minute.",
  LOADING_WAITING: "Loading information, please wait.",
  WLAN_INFO: "WLAN information",
  MAC: "MAC",

  UPDATE_WLAN_CONFIG_ERROR: "Unable to connect to the WLAN network. If the problem persists, try restarting the TS Scope ASi or the WLAN router.",

  HOSTNAME_POPUP_1: "A hostname must be between 2 and 64 characters long to be valid.",
  HOSTNAME_POPUP_2: "Additionally, it can only contain letters, numbers, periods, and hyphens, and must begin and end with letters and numbers only.",

  INVALID_HOSTNAME_1: "The hostname must be between 2 and 64 characters long.",
  INVALID_HOSTNAME_2: "The hostname must contain only letters, numbers, periods, and hyphens, and must begin and end with only letters and numbers.",

  HOSTNAME_CONFIG_SUCCESS: "The hostname has been configured successfully.",
  HOSTNAME_CONFIG_ERROR: "An error occurred while configuring the hostname",
  MODE: "Mode",
  HIDDEN_SSID: "Hidden SSID",
  OPTIONAL: " (Optional)",

  ALTER_MONITOR_WLAN_CONFIG: "Are you sure you want to change the WLAN settings of the TS Scope ASi?",

  FIXED_IP: "Fixed IP",

  // ---------------------------- TS EXPERT CONFIG ---------------------------- 
  SENDING_TS_EXPERT_CONFIG_WAITING: "Updating TS Expert settings, please wait a moment.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "TS Expert settings have been saved successfully.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "An error occurred while saving the TS Expert settings.",
  TS_EXPERT_INVERTED_POLARITY_DISABLE_NOT_ALLOWED: "This event cannot be disabled!",

  TS_EXPERT_CONFIGURATION: "TS Expert Settings",

  ASI_ATTENUATED_SIGNAL_LIST_HEADER: "Attenuated signal",
  ASI_ATTENUATED_SIGNAL_LIST_CONTENT: "When this option is activated, TS Expert will indicate to the user a possible condition of attenuated ASi signal.",

  ASI_DEVIATION_LIST_HEADER: "Deviation",
  ASI_DEVIATION_LIST_CONTENT: "When this option is activated, TS Expert will indicate to the user a possible deviation condition in the ASi signal.",

  ASI_NO_SIGNAL_LIST_HEADER: "No signal",

  ASI_NOISE_LIST_HEADER: "Noise",
  ASI_NOISE_LIST_CONTENT: "When this option is enabled, TS Expert will indicate to the user a possible noise condition in the ASi network.",

  ASI_GENERAL_SIGNAL_LOSS_HEADER: "General loss of ASi signal",

  ASI_RETRY_LIST_HEADER: "Retry",
  ASI_RETRY_LIST_CONTENT: "When this option is activated, TS Expert will indicate to the user the possible presence of retries.",

  ASI_FAULT_LIST_HEADER: "Fault",
  ASI_FAULT_LIST_CONTENT: "When this option is activated, TS Expert will indicate a possible fault condition to the user.",

  ASI_INVERTED_POLARITY_LIST_HEADER: "Inverted Polarity",
  ASI_INVERTED_POLARITY_LIST_CONTENT: "When this option is activated, TS Expert will indicate to the user a possible inverted polarity condition.",

  // ---------------------------- TS EXPERT ----------------------------
  SCOPE_TAG: "Scope Tag:",
  CHANNEL_TAG_2: "Channel Tag:",
  TS_EXPERT_REPORT_EXPORT_NAME: "Actions List - TS Expert - TS Scope ASi",

  TS_EXPERT_POPUP_1: "This tab presents the TS Expert information..",
  TS_EXPERT_POPUP_2: "This tool is an expert system developed to optimize and speed up the analysis of the main divergences detected by TS Scope ASi in ASi networks.",
  TS_EXPERT_POPUP_3: "In an automated way, maintenance, engineering and related teams can obtain a list of actions with different events, their possible causes, suggested solutions and the devices on which they were detected.",
  TS_EXPERT_POPUP_4: "The use of TS Expert does not eliminate the need for human analysis, nor does it replace such capabilities to create data correlations and interpretation.",

  TS_EXPERT: "TS Expert",
  DETECTED_ON: "Detected in: ",
  CHECK_YOUR_NETWORK: "Please check your network.",

  EXPORT_ACTIONS_LIST: "Export actions list",
  GENERATING_ACTIONS_LIST_WAITING: "Generating the actions list PDF, please wait.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF generated successfully. To save it, click on save action list.",

  EVENTS_LIST: "List of events",
  ACTIONS: "Actions",

  NO_PROBLEM_DETECTED: "TS Expert has not detected any events on the network.",
  NO_EVENTS_TO_BE_ANALYZED: "There are no events to be analyzed.",

  NO_EVENT_SELECTED: "No events selected",
  CHOOSE_AN_EVENT: "Select an event to view suggested actions.",

  DETAILING: "Details",

  CHECKED: "Check",
  BATCH_CHECK: "Check all",

  PROBLEM_CHECKED: "The event has been successfully checked",
  PROBLEM_CHECK_ERROR: "An error occurred while checking the event.",

  LAST_UPDATED: "Last updated on: ",
  THIS_COMPUTER_TIME: " (This computer's time)",

  DEVICES: "Devices",
  UNKNOWN: "Unknown",

  ALL_EVENTS_WERE_CHECKED: "All events were checked successfully.",
  CHECK_EVENT_OBS: "\nIt is important to note that some data takes up to 15 minutes to be updated, so it is suggested that you wait some time to clear this list by clicking on check.\n",

  UNABLE_TO_CHECK_DEVIATION_EVENTS: "The events for the following devices could not be checked because TS Scope ASi keeps detecting a jitter condition in the ASi network signal:\n",
  UNABLE_TO_CHECK_ATTENUATED_SIGNAL_EVENTS: "It was not possible to check the events of the following devices, as TS Scope ASi continues to detect a signal with an amplitude lower than 4Vpp:\n",
  UNABLE_TO_CHECK_NOISE_EVENTS: "It was not possible to check the events of the following devices, as TS Scope ASi continues to detect a noise condition (amplitude greater than 30% of the slave signal amplitude):\n",
  UNABLE_TO_CHECK_RETRY_EVENTS: "It was not possible to check the events of the following devices, as TS Scope ASi continues to detect retries:\n",
  UNABLE_TO_CHECK_FAULT_EVENTS: "Unable to check events for the following devices as TS Scope ASi continues to detect a fault condition:\n",
  UNABLE_TO_CHECK_INVERTED_POLARITY_EVENTS: "Unable to check events for the following devices because TS Scope ASi keeps detecting an inverted polarity condition:\n",

  SAVE_ACTIONS_LIST: "Save actions list",
  FINISHING: "Finishing...",
  ACTIONS_LIST_SCOPE_CHANNEL: "Actions List - TS Scope ASi - Channel",
  PAGE: "Page",

  // ---------------------------- DESVIO ----------------------------
  DEVIATION_SUGGESTION_1: "The “deviation” alert indicates that TS Scope ASi found in its scans a jitter condition in the ASi network signal.",
  DEVIATION_SUGGESTION_2: "Check the following items:",
  DEVIATION_SUGGESTION_3: "Equipment insulation;",
  DEVIATION_SUGGESTION_4: "Humidity in the bus;",
  DEVIATION_SUGGESTION_5: "Problems with the slave electronics;",
  DEVIATION_SUGGESTION_6: "Oxidation on the slave connections;",
  DEVIATION_SUGGESTION_7: "Oxidation in the junction box/barrier connections;",
  DEVIATION_SUGGESTION_8: "Long cable.",

  // ---------------------------- SINAL ATENUADO ----------------------------
  ATTENUATED_SIGNAL_SUGGESTION_1: "The “attenuated signal” alert indicates that TS Scope ASi found signals with amplitude lower than 4Vpp in its scans..",
  ATTENUATED_SIGNAL_SUGGESTION_2: "Perform the following checks:",
  ATTENUATED_SIGNAL_SUGGESTION_3: "If slave electronics are interfering with the bus, isolate them individually from the bus;",
  ATTENUATED_SIGNAL_SUGGESTION_4: "If there are points of high resistance such as loose bornes and crushed cables.",
  ATTENUATED_SIGNAL_SUGGESTION_5: "If the gateway electronics are interfering with the bus, replacing it with another.",

  // ---------------------------- RUIDO ----------------------------
  NOISE_SUGGESTION_1: "The “noise” alert indicates that TS Scope ASi found in its scans a noise condition with an amplitude greater than 30% of the slave signal amplitude.",
  NOISE_SUGGESTION_2: "Below we have 3 tips to help resolve this issue:",
  NOISE_SUGGESTION_3: "Check the isolation of the slave interfaces, a simple way is to disconnect one by one from the network and check if the problem persists.",
  NOISE_SUGGESTION_4: "To attenuate noise, it is necessary to check that all slaves in the network are properly grounded;",
  NOISE_SUGGESTION_5: "It is necessary to check the equipotentialization of the grounding system, a simple way is to check if there is leakage current in the ASi cables.",

  // ---------------------------- RETENTATIVAS ----------------------------
  RETRY_SUGGESTION_1: "Retries indicate the number of times packet loss occurred and the master had to resend a query to a given device.",
  RETRY_SUGGESTION_2: "Retries are calculated within the monitor's data acquisition buffers, which work by performing acquisitions at intervals, alternating between the 4 channels.",
  RETRY_SUGGESTION_3: "Below we have 3 tips to help solve this issue:",
  RETRY_SUGGESTION_4: "Check for cable damage:",
  RETRY_SUGGESTION_5: "Check if there are power cables close to ASi cables. Data cables must be separated as far as possible or in closed and grounded electrical ducts/conduits, following the minimum indicated by the guidelines according to the electrical conductor classification, EN50174 standard;",
  RETRY_SUGGESTION_6: "If none of the above items solve the problem, and a specific device is experiencing isolated retries (only a specific slave is experiencing retries), it is suggested to replace the slave.",

  // ---------------------------- FALHA ----------------------------
  FAULT_SUGGESTION_1: "The “Fault” state indicates that the slave stopped communicating, that is, it stopped exchanging data with the master (dropped off the network).",
  FAULT_SUGGESTION_2: "In this case, there is no way to determine the exact reason for the failure, so it is suggested:",
  FAULT_SUGGESTION_3: "Check the slave power supply;",
  FAULT_SUGGESTION_4: "Check if it is connected to the network (cable or fiber optic);",
  FAULT_SUGGESTION_5: "Check the integrity and correct assembly of the connector;",
  FAULT_SUGGESTION_6: "Check the integrity of the cable.",

  // ---------------------------- POLARIDADE INVERTIDA ----------------------------
  INVERTED_POLARITY_SUGGESTION_1: "The TS Scope ASi detected that the cables connected to it have reversed polarity. This can cause instability in reading network packets, causing non-existent slaves on the network to appear in the Live List. To correct this problem, reconnect the cables correctly and then restart the TS Scope ASi.",

  // ---------------------------- EXPERT REPORT ----------------------------
  TS_EXPERT_DP: "TS Expert:",
  ACTIONS_LIST: "Actions list",

  REPORT_GENERATION: "- Report generation time:",
  CHANNEL_TAG: "- Channel tag: ",

  ASI_DEVIATION_PAGE_TITLE: ". - Deviation",
  ASI_ATTENUATED_SIGNAL_PAGE_TITLE: ". - Attenuated signal",
  ASI_NOISE_PAGE_TITLE: ". - Noise",
  ASI_FAULT_PAGE_TITLE: ". - Fault",
  ASI_RETRY_PAGE_TITLE: ". - Retry",
  ASI_INVERTED_POLARITY_PAGE_TITLE: ". - Inverted polarity",

  ASI_DEVIATION_DOTS: ".......................................................................................................................................",
  ASI_ATTENUATED_SIGNAL_DOTS: ".........................................................................................................................",
  ASI_NOISE_DOTS: ".............................................................................................................................................",
  ASI_FAULT_DOTS: "..............................................................................................................................................",
  ASI_RETRY_DOTS: "..............................................................................................................................................",
  INVERTED_POLARITY_DOTS: "...........................................................................................................................",
  DISCLAIMER_EXPERT_DOTS: ".................................................................................................................................",

  SUGGESTION: "It is suggested",
  EVIDENCE: "Evidences",
  EVIDENCE_DESCRIPTION: "Capture of the evidence of non-conformity reported by TS Expert:",

  ASI_DEVIATION_PAGE_DESCRIPTION: "TS Expert is indicating a possible deviation condition in the ASi signal.",
  ASI_ATTENUATED_SIGNAL_DESCRIPTION: "TS Expert is indicating a potential attenuated ASi signal condition.",
  ASI_NOISE_DESCRIPTION: "TS Expert is indicating a possible noise condition on the ASi network.",
  ASI_FAULT_DESCRIPTION: "TS Expert is indicating a potential fault condition.",
  ASI_RETRY_DESCRIPTION: "TS Expert is indicating a ptential retry condition.",
  INVERTED_POLARITY_DESCRIPTION: "TS Expert is indicating a possible inverted polarity condition.",

  ASI_FAULT_DESCRIPTION_1: "In cases of failure, capturing evidence of nonconformity is not shown, since there is no ASi signal to be analyzed.",
  ASI_FAULT_DESCRIPTION_2: "For this reason, below is a table containing all devices whose signals were not detected, their respective channels and the time at which the problem was detected.",

  ASI_RETRY_DESCRIPTION_1: "In cases of retries, capturing evidence of non-compliance is not shown.",
  ASI_RETRY_DESCRIPTION_2: "For this reason, below is a table containing all devices whose signals were not detected, their respective channels and the time at which the problem was detected.",

  // ---------------------------- ACTIVE CHANNELS ----------------------------
  ACTIVE_CHANNELS: "Active channels",
  ACTIVE_CHANNELS_POPUP_1: "Allows you to configure which TS Scope ASi channels are currently active (Which channels will be used).",
  ACTIVE_CHANNELS_POPUP_2: "It is recommended to disable all channels that are not currently being used.",
  SAVING_ACTIVE_CHANNELS: "Saving active channels, please wait.",
  SEND_ACTIVE_CHANNELS_SUCCESS: "The active channels have been saved successfully!\nAfter pressing OK you will be redirected to the TS Scope ASi home page.",
  SEND_ACTIVE_CHANNELS_ERROR: "An error occurred while saving active channels",
  CANT_TURN_ALL_CHANNELS_OFF: "It is not possible to deactivate all TS Scope ASi channels at the same time.\n\nAt least one of the channels must remain active.",

  // ---------------------------- ASI NETWORK VERSION ----------------------------
  ASI_NETWORK_VERSION: "ASi network version",
  ASI_NETWORK_VERSION_2: "Version 2.0",
  ASI_NETWORK_VERSION_2_1: "Version 2.1",
  ASI_NETWORK_VERSION_POPUP_1: "Allows you to configure the ASi network version monitored by each TS Scope ASi channel.",
  ASI_NETWORK_VERSION_POPUP_2: "ASi networks using protocol version 2.0 support up to 32 devices per network, addressed from 1 to 32.",
  ASI_NETWORK_VERSION_POPUP_3: "ASi networks that use protocol version 2.1 or higher support up to 64 devices, addressed from 1A to 32A and from 1B to 32B.",
  DISABLED_CHANNELS_POPUP_1: "Some channels may appear as disabled on this screen, and the ASi network version cannot be changed.",
  DISABLED_CHANNELS_POPUP_2: "This occurs when they are turned off, to modify the network version of the channel, go to the channel settings screen and enable them.",
  SEND_ASI_TYPE_SUCCESS_1: "The network version of 'Channel ",
  SEND_ASI_TYPE_SUCCESS_2: "' was saved successfully!",
  SEND_ASI_TYPE_ERROR: "An error occurred while saving the network version of the 'Channel ",

  // ---------------------------- LOADING ----------------------------
  INITIALIZING_SCOPE_DP: "Initializing TS Scope ASi, please wait."

});